import React, { useContext, useEffect, useState }       from "react";
import { Trash }                                        from "react-feather";
import { useForm }                                      from "react-hook-form";
import { Button, Col, Input, Label, Row }               from "reactstrap";
import { getEmployeeByName }                            from "../../../../../services/pages/employee/get";
import { getList }                                      from "../../../../../services/pages/position/getAll";
import { WorkUnitGetList }                              from "../../../../../services/pages/workunit/getWorkUnitList";
import Autocomplete                                     from "../../../../widgets/autocomplete";
import dummyUser                                        from "./dummyuser.json"
import KualContext                                      from "../../../../wrapper/report/kualitatif/context/KualContext";

export default function TerlaporPelaporApi({
    isClear, 
    data, 
    setSelectedEds, 
    onDelete, 
    title, 
    needGolongan, 
    hideWorkunit, 
    edited_val, 
    nama, 
    type, 
    defaultEmployee,
    isErrorValidation
}) {

    const {
        employeeList
    } = useContext(KualContext.Context)

    const { setValue, register, getValues }             = useForm()
    const [suggestionsUser, setSuggestionsUser]         = useState(dummyUser)
    const [suggestionsNIP, setSuggestionsNIP]           = useState(dummyUser)
    const [suggestionsPosition, setSuggestionsPosition] = useState([])
    const [suggestionsWorkunit, setSuggestionsWorkunit] = useState([])
    const [select_suggestions, setSelectSuggestions]    = useState([])
    const [clear, set_clear]                            = useState(false)
    const [isGolongan, setIsGolongan]                   = useState()
    const [refreshValue, setRefreshValue]               = useState(false)
    const [selectFromUpdate, setSelectFromUpdate]       = useState(true)
    const [wid, setWid]                                 = useState("")
    const [isSetWID, setIsSetWID]                       = useState(true)
    const [pid, setPid]                                 = useState("")
    const [isSetPID, setIsSetPID]                       = useState(true)
    const [isSetName, setIsSetName]                     = useState(true)
    const [isSetNIP, setIsSetNIP]                       = useState(true)
    const [statusKepegawaian, setStatusKepegawaian]     = useState("")
    const [golongan, setGolongan]                       = useState("")
    const [valName, setValName]                         = useState("")
    const [valNip, setValNip]                           = useState("")

    const [dtUser, setDtUser]                           = useState({
        uuid                : "",
        name                : "",
        nip                 : "0",
        nrp                 : "0",
        grade               : "",
        position            : "",
        position_id         : 0,
        work_unit           : "",
        work_unit_id        : 0,
        class               : "",
        employment_status   : "",
        type                : type,
    })

    useEffect(() => {
        getEmployeeByName("").then(resp => {
            if (resp.data !== null) {
                setSuggestionsUser(resp.data)    
                let listNip = []

                resp?.data?.map((item) => {
                    listNip.push({
                        name  : item?.nip,
                    })
                })
                setSuggestionsNIP(resp.data)    
            }
        })

        getList().then((response) => {
            if(response.data != null) {
			    setSuggestionsPosition(response.data);
            }
		});

        WorkUnitGetList().then((response) => {
			if(response.data != null) {
			    setSuggestionsWorkunit(response.data);
            }
		}) 

    }, [])

    useEffect(() => {
        if (employeeList !== null) {
            setSuggestionsUser(employeeList)    
            let listNip = []

            employeeList?.map((item) => {
                listNip.push({
                    name  : item?.nip,
                })
            })
            setSuggestionsNIP(employeeList)    
        }
    }, [employeeList])

    useEffect(() => {
        set_clear(isClear)
        let arr = ["nip", "pangkat", "nrp", "workunit_level", "workunit", "position", "employment_status", "class"]
        if (isClear) {
            arr.map(v => {
                setValue(v, "")
            })
        }
    }, [isClear])

    useEffect(() => {
        setIsGolongan(needGolongan === undefined ? false : needGolongan)
    }, [needGolongan])

    useEffect(() => {
        if (data != undefined && data != null) {
            for (let i in data) {
                const sel_i = data[i]
                if (!Array.isArray(sel_i)) {
                    setValue(i, sel_i)
                }
            }
        }
    }, [data])

    useEffect(() => {
        if(defaultEmployee != undefined && defaultEmployee != "") {
            createNewEmployee("uuid",               defaultEmployee?.uuid)
            createNewEmployee("name",               defaultEmployee?.name)
            createNewEmployee("nip",                defaultEmployee?.nip)
            createNewEmployee("nrp",                defaultEmployee?.nrp)
            createNewEmployee("grade",              defaultEmployee?.grade)
            createNewEmployee("employment_status",  defaultEmployee?.employment_status)
            createNewEmployee("class",              defaultEmployee?.class)
            createNewEmployee("position",           defaultEmployee?.position)
            createNewEmployee("position_id",        defaultEmployee?.position_id)
            createNewEmployee("work_unit",          defaultEmployee?.work_unit)
            createNewEmployee("work_unit_id",       defaultEmployee?.work_unit_id)

            setValue("uuid",               defaultEmployee?.uuid)
            setValue("name",               defaultEmployee?.name)
            setValue("nip",                defaultEmployee?.nip)
            setValue("nrp",                defaultEmployee?.nrp)
            setValue("grade",              defaultEmployee?.grade)
            setValue("employment_status",  defaultEmployee?.employment_status)
            setValue("class",              defaultEmployee?.class)
            setValue("position",           defaultEmployee?.position)
            setValue("position_id",        defaultEmployee?.position_id)
            setValue("work_unit",          defaultEmployee?.work_unit)
            setValue("work_unit_id",       defaultEmployee?.work_unit_id)

            setStatusKepegawaian(defaultEmployee?.employment_status)
            setGolongan(defaultEmployee?.class)
            setPid(defaultEmployee?.position)
            setWid(defaultEmployee?.work_unit)
            setValName(defaultEmployee?.name)
            setValNip(defaultEmployee?.nip)
            setIsSetPID(true)
            setIsSetWID(true)
            setIsSetNIP(true)
            setIsSetName(true)
        }

    }, [defaultEmployee])

    useEffect(() => {
        if(suggestionsUser.length > 0) {
            if(selectFromUpdate){
                // if(nama != undefined && nama != "") {
                //     // selectUserHandler(nama)
                // }
            }
        }
    }, [suggestionsUser])

    useEffect(() => {
        if(refreshValue) {
            setRefreshValue(false)
            setSelectedEds(dtUser)
        }
    }, [refreshValue])

    useEffect(() => {
        if(select_suggestions != undefined) {
            for (let i in select_suggestions) {
                const sel_i = select_suggestions[i]
                if (!Array.isArray(sel_i)) {
                    setValue(i, sel_i)
                }
            }
            
            setStatusKepegawaian(defaultEmployee?.employment_status)
            setGolongan(defaultEmployee?.class)
            setPid(defaultEmployee?.position)
            setWid(defaultEmployee?.work_unit)
            setIsSetPID(true)
            setIsSetWID(true)
            setIsSetNIP(true)
            setIsSetName(true)
        }
    }, [select_suggestions])

    const createNewEmployee = (type, value) => {
        let temp = dtUser

        temp[type] = value
        setDtUser({...temp})
        setRefreshValue(true)
        setSelectedEds({...temp})
    }

    const onChangeName = (e) => {
        setSelectFromUpdate(false)
        const sval = e.target.value
        if (!sval == "") {
            createNewEmployee("name", sval)
        }
    }

    const onChangeNip = (e) => {
        setSelectFromUpdate(false)
        const sval = e.target.value

        if (!sval == "") {
            createNewEmployee("nip", sval)
        }
    }

    const onChangePosition = (e) => {
        setSelectFromUpdate(false)
        const sval = e.target.value

        if(sval != "") {
            createNewEmployee("position", sval)
            createNewEmployee("position_id", 0)
        }
    }

    const onChangeWorkunit = (e) => {
        setSelectFromUpdate(false)
        const sval = e.target.value

        if(sval != "") {
            createNewEmployee("work_unit", sval)
            createNewEmployee("work_unit_id", 0)
        }
    }

    const selectUserHandler = (e) => {
        let data = suggestionsUser.filter((item) => item.name == e)

        setSelectedEds(dtUser)
        setSelectSuggestions(data[0])
        createNewEmployee("uuid",               data[0]?.uuid)
        createNewEmployee("name",               data[0]?.name)
        createNewEmployee("nip",                data[0]?.nip)
        createNewEmployee("nrp",                data[0]?.nrp)
        createNewEmployee("grade",              data[0]?.grade)
        createNewEmployee("employment_status",  data[0]?.employment_status)
        createNewEmployee("class",              data[0]?.class)
        createNewEmployee("position",           data[0]?.position)
        createNewEmployee("position_id",        data[0]?.position_id)
        createNewEmployee("work_unit",          data[0]?.workunit)
        createNewEmployee("work_unit_id",       data[0]?.workunit_id)

        setStatusKepegawaian(defaultEmployee?.employment_status)
        setGolongan(defaultEmployee?.class)
        setPid(data[0]?.position)
        setWid(data[0]?.workunit)
        setValName(data[0]?.name)
        setValNip(data[0]?.nip)
        setIsSetPID(true)
        setIsSetWID(true)
        setIsSetNIP(true)
        setIsSetName(true)

        setSelectFromUpdate(false)
    }

    const selectNipHandler = (e) => {
        let data = suggestionsUser.filter((item) => item.nip == e)

        setSelectedEds(dtUser)
        setSelectSuggestions(data[0])
        createNewEmployee("uuid",               data[0]?.uuid)
        createNewEmployee("name",               data[0]?.name)
        createNewEmployee("nip",                data[0]?.nip)
        createNewEmployee("nrp",                data[0]?.nrp)
        createNewEmployee("grade",              data[0]?.grade)
        createNewEmployee("employment_status",  data[0]?.employment_status)
        createNewEmployee("class",              data[0]?.class)
        createNewEmployee("position",           data[0]?.position)
        createNewEmployee("position_id",        data[0]?.position_id)
        createNewEmployee("work_unit",          data[0]?.workunit)
        createNewEmployee("work_unit_id",       data[0]?.workunit_id)

        setStatusKepegawaian(data[0]?.employment_status)
        setGolongan(data[0]?.class)
        setPid(data[0]?.position)
        setWid(data[0]?.workunit)
        setValName(data[0]?.name)
        setValNip(data[0]?.nip)
        setIsSetPID(true)
        setIsSetWID(true)
        setIsSetNIP(true)
        setIsSetName(true)

        setSelectFromUpdate(false)
    }

    const selectPositionHandler = (e) => {
        let data = suggestionsPosition.filter((item) => item.name == e)
        createNewEmployee("position",           data[0]?.name)
        createNewEmployee("position_id",        data[0]?.id)
    }

    const selectWorkunitHandler = (e) => {
        let data = suggestionsWorkunit.filter((item) => item.name == e)
        createNewEmployee("work_unit",           data[0]?.name)
        createNewEmployee("work_unit_id",        data[0]?.id)
    }

    const isErrValid = (value) => {
        let isError = false

        if (isErrorValidation) {
            if (value) {
                if (value == "") {
                    isError = true
                } else if (value == 0) {
                    isError = true
                } else {
                    isError = false
                }
            } else {
                isError = true
            }
        }
        return isError
    }

    useEffect(() => {
        createNewEmployee("employment_status", statusKepegawaian)
    }, [statusKepegawaian])

    useEffect(() => {
        createNewEmployee("class", golongan)
    }, [golongan])

    return (
        <>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <Label>NIP</Label>
                            <Autocomplete
                                clear               = {clear}
                                onChange            = {onChangeNip}
                                onSelectItem        = {(e) =>{
                                    setIsSetNIP(true)
                                    selectNipHandler(e.target.innerHTML)
                                }}
                                suggestions         = {suggestionsNIP}
                                className           = {`form-control ${isErrValid(dtUser?.nip) && "border-danger"}`}
                                filterKey           = 'nip'
                                suggestionLimit     = {4}
                                placeholder         = {`NIP..`}
                                value               = {valNip}
                                canSetData          = {isSetNIP}
                                setCanSetData       = {setIsSetNIP}
                            />
                        </Col>
                        <Col>
                            <Label>NRP</Label>
                            <Input
                                innerRef        = {register()}
                                type            = "text" 
                                name            = "nrp"
                                placeholder     = "NRP"
                                className       = {`form-control ${isErrValid(dtUser?.nrp) && "border-danger"}`}
                                onChange        = {(e) => {
                                    createNewEmployee("nrp", e.target.value)
                                }}
                                />
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Label>Pencarian Nama</Label>
                    {data == null || data == undefined ?
                        <Autocomplete
                            clear               = {clear}
                            onChange            = {onChangeName}
                            onSelectItem        = {(e) => {
                                setIsSetName(true)
                                selectUserHandler(e.target.innerHTML)
                            }}
                            suggestions         = {suggestionsUser}
                            className           = {`form-control ${isErrValid(dtUser?.name) && "border-danger"}`}
                            filterKey           = 'name'
                            suggestionLimit     = {4}
                            placeholder         = {`Pencarian Nama`}
                            value               = {valName}
                            canSetData          = {isSetName}
                            setCanSetData       = {setIsSetName}
                        /> : <Input
                            name                = "name"
                            innerRef            = {register()}
                            value               = {valName}
                        />
                    }
                </Col>
                
            </Row>
            <Row>
            <Col>
                <Row>
                    <Col>
                        <Label>Pangkat</Label>
                        <Input
                            innerRef        = {register()}
                            name            = "grade"
                            type            = "text"
                            className       = {`form-control ${isErrValid(dtUser?.grade) && "border-danger"}`}
                            placeholder     = "Pangkat"
                            onChange        = {(e) => {
                                createNewEmployee("grade", e.target.value)
                            }}
                        />
                    </Col>
                    <Col>
                        <Label>Pilih Jabatan</Label>
                            <Autocomplete
                                clear               = {false}
                                onChange            = {onChangePosition}
                                onSelectItem        = {(e) => selectPositionHandler(e.target.innerHTML)}
                                suggestions         = {suggestionsPosition}
                                className           = {`form-control ${isErrValid(dtUser?.position) && "border-danger"}`}
                                filterKey           = 'name'
                                suggestionLimit     = {10}
                                placeholder         = {`Pencarian Jabatan`}
                                value               = {pid}
                                canSetData          = {isSetPID}
                                setCanSetData       = {setIsSetPID}
                            />
                        </Col>
                    </Row>
                </Col>
                {
                    hideWorkunit != true ? (
                        <Col>
                            <Label>Pilih Satuan Kerja</Label>
                            <Autocomplete
                                clear               = {clear}
                                onChange            = {onChangeWorkunit}
                                onSelectItem        = {(e) => selectWorkunitHandler(e.target.innerHTML)}
                                suggestions         = {suggestionsWorkunit}
                                className           = {`form-control ${isErrValid(dtUser?.work_unit) && "border-danger"}`}
                                filterKey           = 'name'
                                suggestionLimit     = {10}
                                placeholder         = {`Pencarian Satuan Kerja`}
                                value               = {wid}
                                canSetData          = {isSetWID}
                                setCanSetData       = {setIsSetWID}
                            />
                        </Col>
                    ) : null
                }

            </Row>
            {
                isGolongan ? <Row className="mb-2">
                    <Col>
                        <Label>Status Kepegawaian</Label>
                        <Input
                            name            = "employment_status"
                            innerRef        = {register()}
                            type            = "select"
                            onChange        = {(e) => {
                                createNewEmployee("employment_status", e.target.value)
                                setStatusKepegawaian(e.target.value)
                            }}
                            value           = {statusKepegawaian}
                            className       = {`form-control ${isErrValid(dtUser?.employment_status) && "border-danger"}`}
                        >
                            <option value="">Pilih Status Kepegawaian</option>
                            <option value="Jaksa">Jaksa</option>
                            <option value="Tata Usaha">Tata Usaha</option>
                        </Input>
                    </Col>
                    <Col>
                        <Label>Golongan</Label>
                        <Input
                            name            = "class"
                            innerRef        = {register()}
                            type            = "select"
                            onChange        = {(e) => {
                                createNewEmployee("class", e.target.value)
                                setGolongan(e.target.value)
                            }}
                            value           = {golongan}
                            className       = {`form-control ${isErrValid(dtUser?.class) && "border-danger"}`}
                        >
                            <option value="">Pilih Golongan</option>
                            <option value="Golongan I">Golongan I</option>
                            <option value="Golongan II">Golongan II</option>
                            <option value="Golongan III">Golongan III</option>
                            <option value="Golongan IV">Golongan IV</option>
                        </Input>
                    </Col>
                </Row> : null
            }
            {
                data != undefined && data != null ? <Row>
                    <Col className="text-right">
                        <Button onClick={onDelete} color="danger" size="sm">
                            <Trash size={14} /> Hapus
                        </Button>
                    </Col>
                </Row> : null
            }
        </>
    )

}